module.exports = __webpack_public_path__ + "img/Cyprus.2bcced01.svg";